<template>
  <modal
    name="referral-modal"
    :width="'100%'"
    :adaptive="true"
    :height="height"
    :max-width="700"
    :scrollable="true"
    @before-close="beforeClose"
  >
    <div class="container modal--container overflow-scroll">
      <div class="d-flex flex-wrap justify-content-end w-100 pt-3 px-2">
        <button @click="$modal.hide('referral-modal')" class="close">
          <p aria-hidden="true" class="close-text">&times;</p>
        </button>
      </div>

      <div class="d-flex align-items-center">
        <div class="d-flex justify-content-center">
          <img
            src="../assets/img/referral-icon.png"
            alt="Referral Icon"
            class="referral-icon"
          />
        </div>

        <div class="px-4">
          <h1>
            Earn a $100 gift card to your favourite hungerhub restaurant partner
            when you refer a friend and their office signs up for hungerhub.
          </h1>

          <p class="caption mt-3 mb-0">
            Treat your friend to a free lunch too!
          </p>
          <p class="caption mt-2">
            Qualified Referrals will receive a free lunch and you'll receive a
            $100 gift card when their office signs up for Uncatering.
          </p>
        </div>
      </div>

      <div class="d-flex flex-row my-5 px-3">
        <input
          v-on:focus="$event.target.select()"
          ref="refLink"
          v-model="refLink"
          id="refLink"
          class="form-control"
          type="text"
          readonly
        />
        <button @click="copyLink" type="button" class="copy-btn hover-gray">
          Copy
        </button>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "ReferralModal",
  props: { height: { default: "auto" } },
  data() {
    return {};
  },
  computed: {
    ...mapState(["employee"]),
    refLink() {
      return `https://hungerhub.typeform.com/to/T8SiV0pK?email=${this.employee.email}&first_name=${this?.employee?.first_name}`;
    }
  },
  methods: {
    beforeClose() {
      document.body.classList.toggle("noscroll");
    },
    copyLink() {
      navigator.clipboard.writeText(this.refLink);
      this.$toasted.show(
        "Your unique links is copied to your clipboard, paste it into an email or any message and send along to as many friends as you’d like."
      );
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 18px;
  font-weight: 500;
  color: #424242;
  text-align: left;
  margin: 0;
}
.caption {
  font-size: 16px;
  color: #707070;
  text-align: left;
}

.copy-btn {
  background-color: #f8d56b;
  color: black;
  margin-left: 20px;
  border-radius: 10px;
  border-width: 0px;
  font-size: 15px;
  padding: 0px 25px;
}

.referral-icon {
  object-fit: contain;
  width: 137px;
  height: 137px;
}

@media (max-width: 767px) {
  h1 {
    font-size: 14px;
  }
  .caption {
    font-size: 13px;
  }

  .referral-icon {
    object-fit: contain;
    width: 80px;
    height: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReferralModal.vue